import { HOST, } from "common/constants";
import { Box, Container } from "@mui/material";
import axios from "axios";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { useParams } from "react-router-dom";

import scss from "./Education.module.scss";
import { HTag } from "components/HTag";
import { useTranslation } from "react-i18next";


const EducationId = () => {
  const { id } = useParams();
  const [education, setEducation] = useState(null);

  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    if (!id) return;

    const fetchEducation = async () => {
      try {
        const { data } = await axios.get(`${HOST}/api/v1/education/${id}/`);
        setEducation(data);
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      }
    };

    fetchEducation();
  }, [id]);

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {});
    return () => Fancybox.destroy();
  }, []);

  const descriptionKey = `description_${currentLang}`;
    const parsedDescription = parse(education?.[descriptionKey] || "", {
      replace: (domNode) => {
        if (
          domNode.name === "img" &&
          domNode.attribs?.src &&
          domNode.attribs.src.startsWith("/")
        ) {
          domNode.attribs.src = HOST + domNode.attribs.src;
          delete domNode.attribs.style;
  
          return (
            <a data-fancybox="gallery" href={domNode.attribs.src}>
              <img
                src={domNode.attribs.src}
                alt="img"
                style={{
                  maxWidth: "100%",
                  width: "100%",
                  height: "auto",
                  display: "block",
                  position: "static",
                }}
              />
            </a>
          );
        }
  
        if (domNode.name === "a" && domNode.attribs?.href) {
          // Если начинается с "/", добавить HOST
          if (domNode.attribs.href.startsWith("/")) {
            domNode.attribs.href = HOST + domNode.attribs.href;
          }
  
          // Открывать в новой вкладке все внешние ссылки
          if (
            domNode.attribs.href.startsWith("http") ||
            domNode.attribs.href.startsWith("https")
          ) {
            domNode.attribs.target = "_blank";
            domNode.attribs.rel = "noopener noreferrer";
          }
        }
  
        return undefined;
      },
    });

  if (!education) return <p>{t("loading")}</p>;


  return (
    <Box>
      <Container>
        <Box className={scss.block} style={{display:"flex" , flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
          <a data-fancybox="gallery" href={education.image}>
            <img
              src={education.image}
              alt={education.title}
              style={{ borderRadius: "10px", width:"100%" }}
            />
          </a>
          <HTag tag="h2">{education[`title_${currentLang}`]}</HTag>
          <Box className={scss.description}>{parsedDescription}</Box>
        </Box>
      </Container>
    </Box>
  );
};

export default EducationId;
